import { ReactElement, useMemo } from "react";
import { MediaQueryKind, useWorkspaceMediaQuery } from "client/Hooks";
import { HubListItem } from "./HubListItem";
import { HubCardItem } from "./HubCardItem/HubCardItem";
import { AnnouncementPreviewItemModel } from "client/Api/Hub/Announcements/announcementViewer";
import { isNotNil } from "client/Misc/utils";
import { parseDtoDate } from "client/DateAndTime/dateTimeUtils";
import { TimeZone } from "client/DateAndTime/timezones";
import { HubItemCategoryListItemModel } from "client/Api/Hub/hub";

export type HubItemProps = {
	item: AnnouncementPreviewItemModel;
	onNavigate(): void;
	trackingId: string;
	timezone: TimeZone;
};

export const HubItem = (props: HubItemProps): ReactElement => {
	const {
		item,
		onNavigate,
		trackingId,
		timezone
	} = props;

	const isMobile: boolean = useWorkspaceMediaQuery(MediaQueryKind.Mobile);

	const categoryNames = useMemo(
		(): readonly string[] => {
			return item.categories
				.map(
					(x: HubItemCategoryListItemModel): string => x.name
				);
		},
		[item.categories]
	);

	return isMobile
		? (
			<HubListItem
				areCommentsEnabled={item.areCommentsEnabled}
				authorName={item.authorName}
				categoryNames={categoryNames}
				media={item.media}
				numberOfComments={item.commentsCount}
				onNavigate={onNavigate}
				publicationDate={parseDtoDate(item.publicationStart)}
				reactionCounters={item.reactionCounters}
				title={item.title}
				isPinned={isNotNil(item.pinDate)}
				trackingId={trackingId}
				timezone={timezone}
				isNew={item.isNew}
			/>
		)
		: (
			<HubCardItem
				item={item}
				onNavigate={onNavigate}
				timezone={timezone}
			/>
		);
};

HubItem.displayName = "HubItem";